module.exports = __webpack_public_path__ + "static/media/noise.a143d315.png";